import { LOCALE_PT_BR } from "constants/date-time";

export const formatValidityDate = (validity) => {
    return validity.split("-").reverse().join("/");
};

export const getValidityYear = (validity) => {
    return validity.split("-")[0];
};

export const getTodayFormatted = () => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
  
    return `${day}/${month}/${year}`;
};

export const getLicenseNumberFromContent = (content) => {
    const jsonContent = JSON.parse(content);
    if ('conteudoNumeroAlvara' in jsonContent) {
        return jsonContent.conteudoNumeroAlvara;
    } else {
        return undefined;
    }
};

export const getTaximeterNumberFromContent = (content) => {
    const jsonContent = JSON.parse(content);
    if ('conteudoNumeroTaximetro' in jsonContent) {
        return jsonContent.conteudoNumeroTaximetro;
    } else {
        return undefined;
    }
};

export const formatExtendedPtBr = (dateStr) => {
    if (!dateStr) return "";
    const [d2, m, y] = dateStr.split("/");
    const d = new Date(Number(y), Number(m) - 1, Number(d2));

    return isNaN(d) ? dateStr : d.toLocaleDateString(LOCALE_PT_BR, { day: "2-digit", month: "long", year: "numeric" });
}

export const updateContentLicenseNumber = (content, number) => {
    const jsonContent = content ? JSON.parse(content) : {};
    if (number === undefined || number === null || number === '') {
        delete jsonContent.conteudoNumeroAlvara;
    } else {
        jsonContent.conteudoNumeroAlvara = number;
    }
    return JSON.stringify(jsonContent);
};

export const updateContentTaximeterNumber = (content, number) => {
    const jsonContent = content ? JSON.parse(content) : {};
    if (number === undefined || number === null || number === '') {
        delete jsonContent.conteudoNumeroTaximetro;
    } else {
        jsonContent.conteudoNumeroTaximetro = number;
    }
    return JSON.stringify(jsonContent);
};